import React, { useState, useRef } from "react";
import { Volume2, Loader2, Pause } from "lucide-react";
import { API } from "../lib/api";
import { useI18n } from "../i18n";
import { getStoredUser } from "./RegisterModal";

export default function TtsButton({ text, className = "" }) {
  const { lang } = useI18n();
  const [state, setState] = useState("idle"); // idle | loading | playing
  const audioRef = useRef(null);

  const play = async () => {
    if (state === "playing") {
      audioRef.current?.pause();
      setState("idle");
      return;
    }
    setState("loading");
    try {
      const email = getStoredUser()?.email || null;
      const res = await fetch(`${API}/ai/tts`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ text: text.slice(0, 3800), lang, voice: "nova", email }),
      });
      if (res.status === 402) {
        const j = await res.json().catch(() => ({}));
        window.dispatchEvent(new CustomEvent("goldora:quota-blocked", { detail: { ...(j.detail || {}), feature: "tts" } }));
        setState("idle");
        return;
      }
      if (!res.ok) throw new Error("tts-failed");
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current = null;
      }
      const a = new Audio(url);
      audioRef.current = a;
      a.onended = () => {
        setState("idle");
        URL.revokeObjectURL(url);
      };
      a.onerror = () => setState("idle");
      await a.play();
      setState("playing");
    } catch (e) {
      console.warn("tts", e);
      setState("idle");
    }
  };

  return (
    <button
      type="button"
      onClick={play}
      data-testid="tts-play-btn"
      className={`inline-flex items-center justify-center w-8 h-8 rounded-md border border-white/10 bg-white/5 hover:bg-white/10 hover:border-gold-500/40 text-neutral-400 hover:text-gold-400 transition-colors ${className}`}
      title="Play"
    >
      {state === "loading" ? (
        <Loader2 size={13} className="animate-spin" />
      ) : state === "playing" ? (
        <Pause size={13} />
      ) : (
        <Volume2 size={13} />
      )}
    </button>
  );
}
